import { defineMessages } from "react-intl"

export const newsEditorMessages = defineMessages({
	allMarketplaces: {
		defaultMessage: "All markets",
		id: "newsEditor.allMarketplaces",
	},
	backToOverview: {
		defaultMessage: "Back to overview",
		id: "newsEditor.backToOverview",
	},
	content: {
		defaultMessage: "Content",
		id: "newsEditor.content",
	},
	contentContainsLink: {
		defaultMessage: "Links are not allowed in the content",
		id: "newsEditor.contentContainsLink",
	},
	deleteImage: {
		defaultMessage: "Delete image",
		id: "newsEditor.deleteImage",
	},
	discard: {
		defaultMessage: "Discard",
		id: "newsEditor.discard",
	},
	errorLoadingEntry: {
		defaultMessage: "An error occurred while loading the news entry",
		id: "newsEditor.errorLoadingEntry",
	},
	errorPublishing: {
		defaultMessage: "An error occurred while publishing the news entry",
		id: "newsEditor.errorPublishing",
	},
	errorSavingEntry: {
		defaultMessage: "An error occurred while saving the news entry",
		id: "newsEditor.errorSavingEntry",
	},
	errorSendingToReview: {
		defaultMessage: "An error occurred while sending the news entry to review",
		id: "newsEditor.errorSendingToReview",
	},
	imageAlt: {
		defaultMessage: "Image {position} of {total}",
		id: "newsEditor.imageAlt",
	},
	imageInvalidType: {
		defaultMessage: "Only JPG, PNG and WebP images are allowed.",
		id: "newsEditor.imageInvalidType",
	},
	images: {
		defaultMessage: "Images",
		id: "newsEditor.images",
	},
	imagesDescription: {
		defaultMessage:
			"Upload up to {maxImages} images. JPG, PNG or WebP. The first image is shown as hero in teaser view.",
		id: "newsEditor.imagesDescription",
	},
	imageTooLarge: {
		defaultMessage: "Images must not be larger than {maxSizeInMb} MB.",
		id: "newsEditor.imageTooLarge",
	},
	imageTooMany: {
		defaultMessage: "You can add up to {maxImages} images.",
		id: "newsEditor.imageTooMany",
	},
	imageUploadFailed: {
		defaultMessage: "The image {name} could not be uploaded.",
		id: "newsEditor.imageUploadFailed",
	},
	languageCoverageShowLess: {
		defaultMessage: "Show less",
		id: "newsEditor.languageCoverage.showLess",
	},
	languageCoverageShowMore: {
		defaultMessage: "Show {count} more",
		id: "newsEditor.languageCoverage.showMore",
	},
	languageCoverageSubtitle: {
		defaultMessage: "Shows the review status of each market. Editing happens in the market contact's own view.",
		id: "newsEditor.languageCoverage.subtitle",
	},
	languageCoverageTitle: {
		defaultMessage: "Language coverage",
		id: "newsEditor.languageCoverage.title",
	},
	languageStatusNotReviewed: {
		defaultMessage: "Not yet reviewed",
		id: "newsEditor.languageStatus.notReviewed",
	},
	languageStatusReviewed: {
		defaultMessage: "Reviewed",
		id: "newsEditor.languageStatus.reviewed",
	},
	livePreview: {
		defaultMessage: "Live preview",
		id: "newsEditor.livePreview",
	},
	marketplaceAbuDhabi: {
		defaultMessage: "Abu Dhabi",
		id: "newsEditor.marketplace.xa",
	},
	marketplaceDubai: {
		defaultMessage: "Dubai",
		id: "newsEditor.marketplace.xd",
	},
	marketplacePorscheWerkswagen: {
		defaultMessage: "Porsche Werkswagen",
		id: "newsEditor.marketplace.xp",
	},
	marketplaces: {
		defaultMessage: "Markets",
		id: "newsEditor.marketplaces",
	},
	modalCancel: {
		defaultMessage: "Cancel",
		id: "newsEditor.modal.cancel",
	},
	pageTitleEdit: {
		defaultMessage: "Edit entry",
		id: "newsEditor.pageTitleEdit",
	},
	pageTitleNew: {
		defaultMessage: "New entry",
		id: "newsEditor.pageTitleNew",
	},
	plannedPublicationDate: {
		defaultMessage: "Planned publication date",
		id: "newsEditor.plannedPublicationDate",
	},
	publish: {
		defaultMessage: "Publish",
		id: "newsEditor.publish",
	},
	publishModalMessage: {
		defaultMessage: 'Do you really want to publish the entry "{title}" to all selected markets?',
		id: "newsEditor.publishModal.message",
	},
	publishModalTitle: {
		defaultMessage: "Publish entry",
		id: "newsEditor.publishModal.title",
	},
	readOnlyHint: {
		defaultMessage: "This entry can no longer be edited",
		id: "newsEditor.readOnlyHint",
	},
	saveAsDraft: {
		defaultMessage: "Save as draft",
		id: "newsEditor.saveAsDraft",
	},
	sendToReview: {
		defaultMessage: "Send to review",
		id: "newsEditor.sendToReview",
	},
	sendToReviewModalMessage: {
		defaultMessage:
			'Do you really want to send the entry "{title}" to review? It can no longer be edited afterwards.',
		id: "newsEditor.sendToReviewModal.message",
	},
	sendToReviewModalTitle: {
		defaultMessage: "Send entry to review",
		id: "newsEditor.sendToReviewModal.title",
	},
	sourceLanguage: {
		defaultMessage: "English, source language",
		id: "newsEditor.sourceLanguage",
	},
	title: {
		defaultMessage: "Title",
		id: "newsEditor.title",
	},
	toolbarBold: {
		defaultMessage: "Bold",
		id: "newsEditor.toolbar.bold",
	},
	toolbarBulletList: {
		defaultMessage: "Bulleted list",
		id: "newsEditor.toolbar.bulletList",
	},
	toolbarHeading: {
		defaultMessage: "Heading",
		id: "newsEditor.toolbar.heading",
	},
	toolbarItalic: {
		defaultMessage: "Italic",
		id: "newsEditor.toolbar.italic",
	},
	toolbarLabel: {
		defaultMessage: "Formatting",
		id: "newsEditor.toolbar.label",
	},
	toolbarOrderedList: {
		defaultMessage: "Numbered list",
		id: "newsEditor.toolbar.orderedList",
	},
	uploadImages: {
		defaultMessage: "Upload images",
		id: "newsEditor.uploadImages",
	},
	uploadingImage: {
		defaultMessage: "Uploading image",
		id: "newsEditor.uploadingImage",
	},
})
